import screens from '@/helpers/screens.json'
import photoPlaceholder from '@/assets/images/product-image-placeholder.jpg'
import { get } from 'lodash'

function ensureAdd(arr, el) {
  if (!arr.includes(el)) {
    arr.push(el);
  }
}

function ensureRemove(arr, el) {
  const ind = arr.indexOf(el);
  if (ind >= 0) {
    arr.splice(ind, 1);
  }
}

function detectWebpSupport() {
  const canvas = document.createElement('canvas')

  if (!!(canvas.getContext && canvas.getContext('2d'))) {
    return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }

  return false
}

export default {
  namespaced: true,

  state: {
    sidebarIsOpen: false,
    cartModalIsActive: false,
    authModalIsActive: false,
    bodyScrollBlockers: [],
    modalMaskers: [],
    dropdownModals: [],
    photoPlaceholder,
    screenWidth: undefined,
    canUseWebp: undefined,
    vkMiniApp: get(window.__appState, 'custom_context.vk_mini_app') === true,
    tabId: Math.random().toString().replace('.', ''),
  },

  getters: {
    sidebarIsOpen(state) {
      return state.sidebarIsOpen
    },

    cartModalIsActive(state) {
      return state.cartModalIsActive
    },

    authModalIsActive(state) {
      return state.authModalIsActive
    },

    bodyScrollBlocked(state) {
      // The value of this getter currently
      return state.bodyScrollBlockers.length > 0;
    },

    photoPlaceholder(state) {
      return state.photoPlaceholder
    },

    shouldDisplayDropdownMask(state) {
      if (state.modalMaskers.length !== 0) {
        return false
      }

      return state.dropdownModals.length > 0
    },

    // This method should be preferred over comparing `state.screenWidth` manually to avoid `>` | `>=` confusion.
    isBreakpointActive(state) {
      if (typeof state.screenWidth !== 'number') return null;

      return breakpointName => {
        const breakpointPx = screens[breakpointName];

        if (process.env.NODE_ENV !== 'production') {
          if (typeof breakpointPx !== 'number') {
            throw new Error(`Unrecognized breakpoint "${breakpointName}"`);
          }
        }

        return state.screenWidth >= breakpointPx;
      }
    },

    canUseWebp(state) {
      if (state.canUseWebp === undefined) {
        state.canUseWebp = detectWebpSupport()
      }

      return state.canUseWebp
    },

    vkMiniApp(state) {
      return state.vkMiniApp
    },

    tabId(state) {
      return state.tabId;
    },
  },

  mutations: {
    setSidebarState(state, value) {
      state.sidebarIsOpen = value
    },

    /**
     * Subsequent calls with the same identifier have no effect.
     * @param {any} id - any identifier by which we can unregister it later. E.g. a string, or `this`.
     */
    registerBodyScrollBlocker(state, id) {
      ensureAdd(state.bodyScrollBlockers, id);
    },

    /**
     * @see registerBodyScrollBlocker
     */
    unregisterBodyScrollBlocker(state, id) {
      ensureRemove(state.bodyScrollBlockers, id);
    },

    registerModalMasker(state, id) {
      ensureAdd(state.modalMaskers, id);
    },
    unregisterModalMasker(state, id) {
      ensureRemove(state.modalMaskers, id);
    },

    registerDropdownModal(state, id) {
      ensureAdd(state.dropdownModals, id);
    },
    unregisterDropdownModal(state, id) {
      ensureRemove(state.dropdownModals, id);
    },

    toggleCartModal(state) {
      let timeout = 0

      if (state.authModalIsActive && !state.cartModalIsActive) {
        state.authModalIsActive = false
        timeout = 300
      }

      setTimeout(() => state.cartModalIsActive = !state.cartModalIsActive, timeout)
    },

    toggleAuthModal(state) {
      let timeout = 0

      if (state.cartModalIsActive && !state.authModalIsActive) {
        state.cartModalIsActive = false
        timeout = 300
      }

      setTimeout(() => state.authModalIsActive = !state.authModalIsActive, timeout)
    },

    setScreenWidth(state, newVal) {
      state.screenWidth = newVal;
    }
  },

  actions: {
    setScreenWidth({ commit }, newVal) {
      commit('setScreenWidth', newVal);
    },
  },
}
